import React from "react";
import MentiAvatar from '../../images/menti_bot.png'
interface EducationalContext {
  className?: string;
  subjectName?: string;
  seriesName?: string;
  chapterName?: string;
  topicName?: string | null;
}

interface ChatHeaderProps {
  context?: EducationalContext;
  conversationTitle?: string | null;
}

export default function ChatHeader({
  context,
  conversationTitle,
}: ChatHeaderProps) {
  const learningPath = context
    ? [
        context.className,
        context.subjectName,
        context.seriesName,
        context.chapterName,
        context.topicName,
      ]
        .filter(Boolean)
        .join(" › ")
    : "Document Menti AI Tutor";

  return (
    <header className="chat-header">

      <div className="chat-header-left">

        <div className="chat-avatar">
          <img src={MentiAvatar} alt="Menti AI" width="50"/>
        </div>

        <div>

          <h4 className="chat-title">
            {conversationTitle || "Menti AI Tutor"}
          </h4>

          <div className="chat-subtitle">
            {learningPath}
          </div>

        </div>

      </div>

      <div className="chat-header-right">
        <div className="status-badge">
          <span className="status-dot"></span>
          Online
        </div>
      </div>

    </header>
  );
}